<template>
    <div  :class="baseerp+'div'" >
        <el-row class="video-tree flex" >

            <el-col :span="treespan"  v-show="isright" >
                <kh-list @click="changeData"></kh-list>
            </el-col>
            <el-col :span="24 - treespan"  style="height: 100%;min-width: 320px;width: 100%">
                <div class="  w100" >
                        <div class="flex">
                            <el-button type="text" style=" margin-left: 6px;" :class="[baseerp+'color','nopadding']"   @click="isright=!isright"  :icon="isright?'el-icon-s-fold':'el-icon-s-unfold'"></el-button>
                            <el-date-picker
                                    style="width:210px; margin-right: 9px; margin-left: 9px;"
                                    size="mini"
                                    :clearable="false"
                                    :unlink-panels="true"
                                    v-model="searchTime"
                                    type="daterange"
                                    format="yyyy-MM-dd"
                                    value-format="yyyy-MM-dd"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期"
                            @change="dateChange">
                            </el-date-picker>
                            <el-button class="marB10" @click="addNewFun" :class="baseerp+'btn'" size="mini">
                                添加收款
                            </el-button>

                            <el-button class="marB10" @click="ckysFun" :class="baseerp+'btn'" size="mini" >
                                查看应收
                            </el-button>
                            <el-button class="marB10" @click="dcFun" plain  size="mini">
                                导出
                            </el-button>
                            <el-input style=" margin-left: 6px;width:200px" v-model="search" placeholder="搜索" size="mini" @change="searchFun">
                                <el-button  slot="append" icon="el-icon-search"  size="mini" @click="searchFun" ></el-button>
                            </el-input>
                        </div>
                    <div :class="['dib',ckys?'w100-480':'wi']" >
                         <el-table
                                class="mrt10"
                                ref="table"
                                size="mini"
                                :height="tableHeight"
                                border
                                :data="tableData"
                                :header-cell-style="{background:'#eef1f6',color:'#000'}"
                                :highlight-current-row="true"

                                style="width: 100%">
                            <el-table-column
                                    :label="$t('form_serial_number')"
                                    align="center"
                                    type="index"
                                    width="50px">
                            </el-table-column>

                            <el-table-column
                                    align="center"
                                    label="到账日期"
                                    prop="dt_paytime" width="80px" show-overflow-tooltip>
                            </el-table-column>
                            <el-table-column
                                    :filters=lxfilterList
                                    :filter-method="lxfilterFun"
                                    align="center"
                                    label="类型"
                                    prop="vc_fktype" width="60px" show-overflow-tooltip>
                            </el-table-column>
                            <el-table-column
                                    align="center"
                                    label="是否预收"
                                    prop="vc_isys" width="50px" show-overflow-tooltip>
                            </el-table-column>
                            <el-table-column
                                    align="center"
                                    label="汇票编码"
                                    prop="vc_hpcode"  show-overflow-tooltip>
                            </el-table-column>
                            <el-table-column
                                    :filters=bzfilterList
                                    :filter-method="bzfilterFun"
                                    align="center"
                                    label="币种"
                                    prop="vc_bzname" width="60px" show-overflow-tooltip>
                            </el-table-column>
                            <el-table-column
                                    align=""
                                    label="汇率"
                                    prop="f_rate" width="90px" show-overflow-tooltip>
                                <template slot-scope="scope">
                                    <div style="text-align: right !important;">{{scope.row.f_rate}}</div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    align=""
                                    label="到账金额"
                                    prop="f_pay" show-overflow-tooltip>
                                <template slot-scope="scope">
                                    <div style="text-align: right !important;">{{scope.row.f_pay}}</div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    :filters="[{text:'作废',value:'作废'},{text:'-',value:'-'}]"
                                    :filter-method="ztfilterFun"
                                    align="center"
                                    label="状态"
                                    prop="vc_state" width="50px" show-overflow-tooltip>
                            </el-table-column>
                            <el-table-column
                                    align="center"
                                    :label="$t('form_notes')"
                                    prop="vc_note"  show-overflow-tooltip>
                            </el-table-column>
                            <el-table-column
                                    align="center"
                                    label="付款方"
                                    prop="vc_khname"  show-overflow-tooltip>
                            </el-table-column>
                            <el-table-column
                                    align="center"
                                    label="收款公司"
                                    prop="vc_gsname" show-overflow-tooltip>
                            </el-table-column>
                            <el-table-column
                                    align="center"
                                    label="录入人"
                                    prop="vc_lruname"
                                    width="70px"   show-overflow-tooltip>
                            </el-table-column>
                            <el-table-column
                                    align="center"
                                    label="录入时间"
                                    prop="dt_createtime" width="80px" show-overflow-tooltip>
                            </el-table-column>
                            <el-table-column
                                    align="center"
                                    label="作废人"
                                    prop="vc_cancel_uname"
                                    width="70px"   show-overflow-tooltip>
                            </el-table-column>
                            <el-table-column
                                    align="center"
                                    label="作废时间"
                                    prop="dt_canceltime" width="80px" show-overflow-tooltip>
                            </el-table-column>
                            <el-table-column
                                    fixed="right"
                                    align="center"
                                    label="操作"
                                    prop="dt_zftime" width="40px"  show-overflow-tooltip>
                                <template slot-scope="scope">
                                    <el-button type="text"   size="small" @click="cancelFun(scope.row)">{{$t('button_nullify')}}</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <el-pagination  style="margin-top: 10px;text-align: right"
                                        background
                                        @current-change="pageCurrentChange"
                                        @size-change="sizeChange"
                                        :page-sizes="[20,50,100]"
                                        layout="total,sizes,prev, pager, next"
                                        :current-page.sync="currentPage"
                                        :total="total"
                                        :page-size="pageSize">
                        </el-pagination>
                    </div>
                    <div v-if="ckys" class="ckys">
                        <ys-list :data="ysdata" @close="closeys"></ys-list>
                    </div>
                </div>


            </el-col>
        </el-row>
        <el-dialog title="添加收款"
                   width="50%"
                   top="50px"
                   class="minw840"

                   v-if="dialogtreeVisibleW"
                   :visible.sync="dialogtreeVisibleW"
                   :modal-append-to-body="false"
                   :close-on-click-modal="false">
            <add-new  @close="addClose" :data="addData"></add-new>
        </el-dialog>
        <div class="contentLeft">
            <reportdialog  ref="mydialog"  ></reportdialog>
            <eDialog ref="eDialog" :activePage="activePage"></eDialog>
        </div>
    </div>
</template>

<script>
    import * as API from "./api"
    import KhList from "./KhList";
    import YsList from "./YsList";
    import AddNew from "./AddNew";
    import {baseerp} from "@/utils/baseUrl";
    import reportdialog from "@/components/dialog"; // dialog
    import eDialog from "@/components/eDialog"; // dialog
    export default {
        name: "index",
        components: {KhList,YsList,AddNew,reportdialog,eDialog},
        data() {
            return {
                treespan:5,
                isright:true,
                tableHeight:0,
                baseerp:'',
                tableData:[],
                currentPage: 1,
                pageSize: 20,
                total:0,
                endTime:'',
                startTime:'',
                i_gsid:0,
                i_khid:null,
                searchTime:[],
                bzList:[],
                bzfilterList:[],
                lxfilterList:[{value:1,text:'现金'},{value:2,text:'承兑'},{value:3,text:'电汇'},{value:4,text:'支票'},{value:5,text:'汇票'}],
                ckys:false,
                ysdata:{},
                dialogtreeVisibleW:false,
                addData:{},
                search:'',
                activePage:"report/res/spread.vue",

            }
        },
        watch: {

            '$root.workSize':{
                handler(n,o) {
                    this.onResize(n);
                },
                deep:true,
            },
        },
        activated(){
            this.onResize();
        },
        mounted() {
            this.baseerp=baseerp
            this.getDictList()
            this.getDay()
            this.$nextTick(()=>{
                this.onResize();

            })
        },
        methods: {
            onResize (n){
                if (n==undefined) n=this.$root.workSize;

                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight= n.h-100

            },
            dateChange(){
                this.startTime=this.searchTime[0]
                this.endTime=this.searchTime[1]
                this.currentPage=1;
                this.receivableList();
            },
            searchFun(){
                this.currentPage=1;
                this.receivableList();
            },
            changeData(val){
                this.i_gsid=val.i_gsid
                this.i_khid=val.i_khid
                this.vc_khname=val.vc_khname
                this.vc_gsname=val.vc_gsname
                this.currentPage=1
                this.receivableList()
                this.ysdata={
                    i_gsid:this.i_gsid,
                    i_khid:this.i_khid,
                }
            },
            addNewFun(){
                if(this.i_khid){
                    this.dialogtreeVisibleW=true
                    this.addData={
                        i_gsid:this.i_gsid,
                        i_khid:this.i_khid,
                        vc_khname:this.vc_khname,
                        vc_gsname:this.vc_gsname,
                        bzList:this.bzList,
                        // lxList:this.lxfilterList,
                    }
                }else{
                    this.$message.warning('请选择添加账户')
                }

            },
            addClose(type='back'){
                this.dialogtreeVisibleW=false
                if(type=='save'){
                    this.currentPage=1
                    this.receivableList()
                }

            },
            ckysFun(){
                this.ysdata={
                    i_gsid:this.i_gsid,
                    i_khid:this.i_khid,
                }
                this.ckys=true

            },
            closeys(){
                this.ckys=false
            },
            dcFun(){},
            async receivableList(){
                let param={
                    currentPage:this.currentPage,
                    pageSize:this.pageSize,
                    endTime:this.endTime,
                    startTime:this.startTime,
                    i_gsid:this.i_gsid,
                    i_khid:this.i_khid,
                    vc_search:this.search
                };
                let res=await API.receivableList(param);
                if ( res.code == 1 ){
                    this.tableData=res.data
                    this.total=res.total;

                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            cancelFun(row){
                this.$confirm('是否继续作废','提示',{
                    confirmButtonText:'继续',
                    cancelButtonText:'取消',
                    type:'warning'
                }).then(async()=>{
                    this.row=row
                    this.receivableCancel()
                }).catch(()=>{
                    this.$message({
                        type:'info',
                        message:'已取消'
                    })
                })
            },
            async receivableCancel(){
                let param={
                    i_id:this.row.i_id
                };
                let res=await API.receivableCancel(param);
                if ( res.code == 1 ){
                    // this.currentPage=1
                    this.receivableList()

                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            pageCurrentChange(val){
                // console.log(val,"pageval");
                this.currentPage=val;
                //调用列表接口
                this.receivableList();
            },
            sizeChange(val){
                this.pageSize=val;
                this.currentPage=1;
                ///调用列表接口
                this.receivableList();
            },
            getDay(){
                const date=new Date();
                const y=date.getFullYear()
                const m=(date.getMonth()+1).toString().padStart(2,'0');
                const d=date.getDate().toString().padStart(2,'0');
                this.startTime=y+'-'+m+'-'+'01'
                this.endTime=y+'-'+m+'-'+d
                this.searchTime=[ this.startTime,this.endTime]
            },
            async getDictList(){
                let param={
                    vc_type:'bz'
                };
                let res=await API.getDictList(param);
                if ( res.code == 1 ){
                    this.bzList=res.data;
                    let bzL=res.data;
                    bzL.map(bz=>{
                        this.bzfilterList.push({
                            text:bz.vc_name,
                            value:bz.i_id
                        })
                    })
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            bzfilterFun(val,row){
                return row.i_bzid===val
            },
            lxfilterFun(val,row){
                return row.i_sktype===val
            },
            ztfilterFun(val,row){
                // console.log(val,row,'-----')
                return row.vc_state===val
            },
            lookreport() {
                let loading =this.$loading({lock:true,text:"正在加载数据,请稍候...",background:"rgba(0,0,0,0.5)"});

                this.$refs.eDialog.showDialog({
                    title:"报价明细结果报表",
                    parm:{type:'sellpaymentRpt',mid:this.$route.meta.mid,arg:{i_bid_id:row.id}},
                    w:1024,
                    h:768
                });
                loading.close();
                document.addEventListener('click',function(e){
                    loading.close()
                });
                // console.log(res)
            },
        },
    }
</script>

<style lang="scss" scoped>
    .flex{
        display: flex;
        align-items: center;
    }
    .w100{
        width: 100%;
    }
    /deep/{
        .minw840 .el-dialog{
            min-width: 700px;
        }
        .el-table .cell{
            padding-right: 2px;
            padding-left: 2px;
        }
        .el-dialog__title,.el-dialog__headerbtn .el-dialog__close {
            color: white;
        }

    }

    .el-dialog__title,.el-dialog__headerbtn .el-dialog__close {
        color: white;
    }
    .dib{
        display: inline-block;
    }
    .ckys{
        width: 340px;
        display: inline-block;
        margin:-0 4px;
        border: 1px solid #DCDFE6;
    }
    .wi{
        width:inherit;
    }
    .w100-480{
        width: calc(100% - 350px);
    }
</style>